import api from "./API";

const extrair = (resposta) => {
  if (resposta?.data?.status === false) {
    throw new Error(resposta?.data?.message || "Falha ao carregar as views.");
  }
  return resposta?.data?.records || [];
};

export async function listarViews(workspaceId) {
  if (!workspaceId) return [];
  const resposta = await api.get(`/task-views?workspaceId=${workspaceId}`);
  return extrair(resposta);
}

export async function criarView(workspaceId, view) {
  const resposta = await api.post("/task-views", { ...view, workspaceId });
  return resposta?.data?.record;
}

export async function atualizarView(id, view) {
  const resposta = await api.put(`/task-views/${id}`, view);
  return resposta?.data?.record;
}

export async function removerView(id) {
  await api.delete(`/task-views/${id}`);
}
